import { render, staticRenderFns } from "./TargetSavings.vue?vue&type=template&id=3f284f1e&scoped=true"
import script from "./TargetSavings.vue?vue&type=script&lang=js"
export * from "./TargetSavings.vue?vue&type=script&lang=js"
import style0 from "./TargetSavings.vue?vue&type=style&index=0&id=3f284f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f284f1e",
  null
  
)

export default component.exports